import { upperFirst, camelCase } from 'lodash';
export var titleCase = function (str) {
  return upperFirst(camelCase(str));
};